module.exports = __webpack_public_path__ + "audit_trail.dca6b07ecfdcdaaec1fe0efc56c150bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/audit_trail.svg
// module id = 352
// module chunks = 0